import { Button, DialogHeader, DialogBody, DialogFooter } from "@material-tailwind/react";
import { Modal } from "./Modal";
import { t } from "i18next";
import appConfig from "../../../app.config";
import SentryFeedbackButton from "../partials/SentryFeedbackButton";

export const PlaybackIssueModal = ({ ...props }) => (
  <Modal {...props}>{({ handleConfirm, handleCancel }) => (
    <>
      <DialogHeader>
        <div className="font-bebasneue text-3xl sm:text-4xl underline underline-offset-4 tracking-wide">
          {t('dialogs.playback_issue.title')}
        </div>
      </DialogHeader>
      <DialogBody>
        <div className="text-base text-gray-800 font-minion leading-relaxed">
          {t('dialogs.playback_issue.message')}
        </div>
      </DialogBody>
      <DialogFooter className="gap-2">
        <Button variant="outlined" color="gray" onClick={handleCancel} className="mr-auto font-minion text-sm">
          <span>{t('dialogs.close')}</span>
        </Button>
        {appConfig.showFeedback && (
          <SentryFeedbackButton className="inline-flex items-center justify-center border border-gray-500 py-2 px-4 text-sm font-minion text-gray-800" />
        )}
        <Button variant="filled" color="yellow" onClick={handleConfirm} className="font-minion text-sm">
          <span>{t('dialogs.playback_issue.try_again')}</span>
        </Button>
      </DialogFooter>
    </>
  )}</Modal>
);
